/**
 * @flow
 * @relayHash 4a5c0455c1af3dfc00a1b74e4f01aae6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RejectSystemDocumentTemplateInput = {
  document: number,
  comment: string,
  clientMutationId?: ?string,
};
export type RejectSystemDocumentTemplateMutationVariables = {|
  input: RejectSystemDocumentTemplateInput
|};
export type RejectSystemDocumentTemplateMutationResponse = {|
  +rejectSystemDocumentTemplate: ?{|
    +ok: ?boolean,
    +redirectPath: ?string,
    +error: ?any,
  |}
|};
export type RejectSystemDocumentTemplateMutation = {|
  variables: RejectSystemDocumentTemplateMutationVariables,
  response: RejectSystemDocumentTemplateMutationResponse,
|};
*/


/*
mutation RejectSystemDocumentTemplateMutation(
  $input: RejectSystemDocumentTemplateInput!
) {
  rejectSystemDocumentTemplate(input: $input) {
    ok
    redirectPath
    error
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "RejectSystemDocumentTemplateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "rejectSystemDocumentTemplate",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "RejectSystemDocumentTemplateInput!"
      }
    ],
    "concreteType": "RejectSystemDocumentTemplatePayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "ok",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "redirectPath",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "RejectSystemDocumentTemplateMutation",
  "id": "2347655f6d03c5c44ff11695db5e573c",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "RejectSystemDocumentTemplateMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "RejectSystemDocumentTemplateMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
node.text = "mutation RejectSystemDocumentTemplateMutation(\n  $input: RejectSystemDocumentTemplateInput!\n) {\n  rejectSystemDocumentTemplate(input: $input) {\n    ok\n    redirectPath\n    error\n  }\n}\n";
(node/*: any*/).hash = '3532b152ed483f7685f79c8b42152d2c';
module.exports = node;
